import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as XLSX from 'xlsx/xlsx.mjs'  
import { addMoreParticipants,setErrors, deleteParticipant, updateInput, readExcelFile } from '../../../../../../features/add-participants/add-participants-slice'
import { validateStep2 } from '../Validations/validation'

const EditPartcipantsNameModal = ({target}) => {
 
    const dispatch = useDispatch()
    const { formData, errors } = useSelector( state => state.addParticipants );
    const [ isExcelFile, setIsExcelFile ] = useState(true)

    const uploadExcelTemplate =  e => {

        const excelSheet = e.target.files[0]
 
        if(!excelSheet.name.includes('.xl')){
            setIsExcelFile(false)
        }
        else{
           setIsExcelFile(true)
           const promise = new Promise( ( resolve , reject ) => {
               const fileReader = new FileReader();
               fileReader.readAsArrayBuffer(excelSheet);
 
               fileReader.onload = event => {
                   const bufferArray = event.target.result;
                   const workBook = XLSX.read(bufferArray, { type : 'buffer' });
                   const workSheetName = workBook.SheetNames[0]
                   const workSheet = workBook.Sheets[ workSheetName ]
                   const dataArray = XLSX.utils.sheet_to_json( workSheet ) ;
 
                   resolve(dataArray)
               }
 
               fileReader.onerror = error => {
                   reject(error)
               }
           })
 
           promise.then( data => {
              //check if the data is in the rigth format
              const checkKey = (key) => data[0].hasOwnProperty(key)
              if( 
                     !checkKey('NAME') || !checkKey('EMAIL') || !checkKey('DEV COACH NAME') 
                     || !checkKey('DEV COACH EMAIL') || !checkKey('PASSWORD') ) 
                {
                  setIsExcelFile(false)                                 
                }
              else {
                  dispatch( readExcelFile( data ) )                
                  setIsExcelFile(true)                
                  window.scrollTo({ top : 600 , behavior:'smooth'})     
                  e.target.value = null             
              }
           })
        }
   }

   const handleAddMoreParticipants = (id) => {
       dispatch( addMoreParticipants(id) )
   }

    const HandleDeleteParticipant = id => {
        dispatch( deleteParticipant(id) )
    }

    const handleInputChange = (id,field,value) => {
        dispatch( updateInput( { id, field, value } ) )
    }

    const updateParticipants = () => {
        const { validated , errors }  = validateStep2(formData)
        if(validated){
            //
        }
        else dispatch(  setErrors(errors) )
    }

  return (
    <div className='modal fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto' id={ target } tabIndex='-1' aria-labelledby='exampleModalLgLabel' aria-modal='true' role='dialog'>
       <div className='modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable  relative w-auto pointer-events-none'>
          <div className='modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current'>
            <div className='modal-header flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md'>
            <h5 className='text-xl bi bi-pencil font-medium leading-normal text-gray-800' id='exampleModalLgLabel'>
                &nbsp;  <span className='text-[16px]'> Edit Partcipants </span>
            </h5>
            <button type='button' id='close-participants-modal'
                className='btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline'
                data-bs-dismiss='modal' aria-label='Close'></button>
            </div>
            <div className='modal-body relative p-4 px-8'>                                        
                <div className='mt-3'>
                        <p className='pb-5 text-sm'> Click the button below to upload partcipants using template. </p>
                       <input type='file' name='file' onChange={ uploadExcelTemplate } id='file' className='hidden' />
                        <label htmlFor='file' className='text-white bg-green-small py-2 px-8 rounded-lg bi bi-cloud-arrow-up text-md'>
                             &nbsp; Upload Participants
                        </label>
                        <br /><br />
                      {
                         !isExcelFile && <div className='border-l px-5 inline-block w-auto border-l-2 border-red-500 text-[13px] bg-red-100 py-2 pl-2 text-red-500 mt-2'>
                             Error:  File is not an valid excel document.
                         </div>
                      }
                </div>
                <h5 className='text-md md:ml-2 bi bi-people mt-5'> 
                    &nbsp; Add Participants & Development Coach 
               </h5>
                 <div className='flex flex-col '>
                    <div className='overflow-x-auto sm:-mx-6 lg:-mx-8'>
                        <div className='py-2 inline-block min-w-full px-5'>
                        <div className='overflow-hidden'>
                            <table className='min-w-full text-center'>
                               <thead>
                                    <tr>
                                        <th scope='col' className='text-[13px] font-medium text-gray-900 px-3 py-2'>
                                            
                                        </th>
                                        <th scope='col' className='text-[13px] font-medium text-gray-900 px-3 py-2'>
                                             Name
                                        </th>
                                        <th scope='col' className='text-[13px] font-medium text-gray-900 px-3 py-2'>
                                            Email Address
                                        </th>
                                        <th scope='col' className='text-[13px] font-medium text-gray-900 px-3 py-2'>
                                           Password
                                        </th>
                                        <th scope='col' className='text-[13px] font-medium text-gray-900 px-3 py-2'>
                                             Development Coach Name
                                        </th>
                                        <th scope='col' className='text-[13px] font-medium text-gray-900 px-3 py-2'>
                                           Development Coach Email
                                        </th>                                         
                                    </tr>
                            </thead>
                            <tbody>                            
                                {
                                    formData.participants.map(
                                        (participant,id) => {
                                            return (
                                                <tr key={id}>
                                                    <td className='px-3 py-2 whitespace-nowrap text-[13px] font-medium text-gray-900'>
                                                        { id + 1}.  
                                                    </td>
                                                    <td className='text-[13px] text-gray-900 font-light px-3 py-2 whitespace-nowrap'>
                                                        <input 
                                                             type="text" name="name"                                                              
                                                              value={ participant.name }
                                                              onChange = { (e) => handleInputChange(id,e.target.name,e.target.value) }
                                                             id="" className='admin-form-input'
                                                              style={{ paddingTop : 7 , paddingBottom : 7}} 
                                                        />
                                                    </td>
                                                    <td className='text-[13px] text-gray-900 font-light px-3 py-2 whitespace-nowrap'>
                                                        <input 
                                                            type="text" name="email" id="" 
                                                             value={ participant.email }                                                             
                                                             onChange = { (e) => handleInputChange(id,e.target.name,e.target.value) }
                                                            className='admin-form-input' 
                                                            style={{ paddingTop : 7 , paddingBottom : 7}}
                                                         />
                                                    </td>
                                                    <td className='text-[13px] text-gray-900 font-light px-3 py-2 whitespace-nowrap'>                                                         
                                                        <input 
                                                              type="password" name="password" id="" 
                                                              value={ participant.password }
                                                              className='admin-form-input'                                                              
                                                               onChange = { (e) => handleInputChange(id,e.target.name,e.target.value) }
                                                               style={{ paddingTop : 7 , paddingBottom : 7}} 
                                                         />
                                                    </td>
                                                    <td className='text-[13px] text-gray-900 font-light px-3 py-2 whitespace-nowrap'>
                                                        <input 
                                                             value={ participant.dev_coach_email }
                                                             type="text" name="dev_coach_email" id="" 
                                                             className='admin-form-input'                                                              
                                                             onChange = { (e) => handleInputChange(id,e.target.name,e.target.value) }
                                                             style={{ paddingTop : 7 , paddingBottom : 7}} 
                                                        />
                                                    </td>
                                                    <td className='text-[13px] flex items-center text-gray-900 font-light px-3 py-2 whitespace-nowrap'>
                                                        <input 
                                                             value={ participant.dev_coach_name }
                                                             type="text" name="dev_coach_name" id="" 
                                                             className='admin-form-input'                                                              
                                                             onChange = { (e) => handleInputChange(id,e.target.name,e.target.value) }
                                                             style={{ paddingTop : 7 , paddingBottom : 7}} 
                                                         />
                                                         {  (id > 0 ) && <span 
                                                            onClick={ () => HandleDeleteParticipant(participant.id) }
                                                            className='bi bi-trash ml-3 text-red-500 text-md'
                                                           ></span>}
                                                    </td>                                                    
                                                  </tr>   
                                                )
                                              }
                                           )
                                        }
                                    </tbody>
                                </table>
                              </div>
                           </div>
                         </div>
                    </div>
                     { errors.participant &&
                        <div className='border-l mt-2 border-l-2 border-red-500 text-red-500 text-[13px] text-center py-3 w-[400px] mx-auto bg-red-100'> 
                            {errors.participant} 
                        </div>
                      }
                    <div className='flex  mt-5'>
                        { <button 
                            className='py-2 text-white text-sm bi bi-plus-circle px-8 rounded-lg bg-green-small'
                            onClick={() => handleAddMoreParticipants( Date.now() ) }
                            >
                            &nbsp; Add more
                        </button>}
                  </div>
                <div className='flex justify-end'>
                      <button onClick={ updateParticipants } className='admin-form-btn'>
                         Update <span className='bi bi-arrow-right'>  </span>
                      </button>
                </div>
            </div>
         </div>
       </div>
    </div>
  )
}

export default EditPartcipantsNameModal